import { NextPage } from 'next';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';

import { DataLayerPageTypeEnum } from '@nocowanie/core';

import { MetaTags } from '@app/components/atoms/meta-tags';
import { Checkout } from '@app/components/pages/checkout';
import { BasicTemplate } from '@app/components/templates/basic-template';
import { usePageDataLayerEvents } from '@app/hooks';
import { PageProps } from '@app/models';
import { BaseListingObject } from '@app/models/elastic-search';
import { useNocSmCheckoutPageVisit } from '@app/pages/potwierdz/hooks';
import { indexServerSidePropsHandler } from '@app/pages/potwierdz/index.server-side-props.handler';
import { nocowanieAppStateWrapper } from '@app/state';

interface CheckoutPageProps extends PageProps {
    geoId?: BaseListingObject['legacyCityId'];
}

const CheckoutPage: NextPage<CheckoutPageProps> = ({ geoId, ...props }) => {
    nocowanieAppStateWrapper.useHydration(props);
    useNocSmCheckoutPageVisit();

    const { asPath: pagePath } = useRouter();
    usePageDataLayerEvents({
        pageType: DataLayerPageTypeEnum.Checkout,
        pagePath,
    });

    const { t } = useTranslation('checkout', {
        keyPrefix: 'metaTags',
    });

    return (
        <>
            <MetaTags noIndex={true} title={t('checkoutPageTitle')} />
            <BasicTemplate>
                <Checkout geoId={geoId} />
            </BasicTemplate>
        </>
    );
};

export const getServerSideProps = indexServerSidePropsHandler;

export default CheckoutPage;
